import { render } from "./UpdatePermissionsModal.vue?vue&type=template&id=2c6782fa&scoped=true&ts=true"
import script from "./UpdatePermissionsModal.vue?vue&type=script&lang=ts"
export * from "./UpdatePermissionsModal.vue?vue&type=script&lang=ts"

import "./UpdatePermissionsModal.vue?vue&type=style&index=0&id=2c6782fa&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c6782fa"]])

export default __exports__